import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { openCancelBackgroundJobDialogAction } from '~src/backgroundJob/actions/OpenCancelBackgroundJobDialogAction';
import { IBackgroundJobInfo } from '~src/backgroundJob/types/BackgroundJobs';
import { CompositeSessionInfoSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { FlowOutputStepRunListItemInfo, FlowOutputStepRunStatus } from '../models/FlowOutputStepRunInfo';

// A flow run can only be cancelled while it is still pending or in progress; once it reaches a
// terminal state (success/failed/cancelled) there is nothing left to cancel.
const CANCELLABLE_STATUSES: ReadonlyArray<string> = [
  FlowOutputStepRunStatus.pending,
  FlowOutputStepRunStatus.inProgress,
];

// Visibility is gated to admins for now, reusing the existing site/server-admin selector.
// Clickability mirrors the Jobs-tab Cancel action, which greys itself out once a job can no longer be
// cancelled. That action reads a server-provided `cancelBackgroundJob` allowed-action flag; flow runs
// don't expose an equivalent flag yet, so we derive the same greyed-out behaviour from the run status
// the item already carries — the button is greyed out once the run is completed, failed, or cancelled.
export const CancelFlowRunEntityAction: IEntityAction<FlowOutputStepRunListItemInfo, {}> = {
  name: EntityActionNames.CancelFlowRun,
  translateName: Messages.cancel,
  isVisible: (_targetItems: FlowOutputStepRunListItemInfo[], state: AppState) =>
    FeatureFlags.flow_cancellation_on_flow_pageEnabled && CompositeSessionInfoSelectors.currentUserIsSiteOrServerAdminSelector(state),
  isClickable: (_availableActions: {} | undefined, targetItems: FlowOutputStepRunListItemInfo[]) =>
    CANCELLABLE_STATUSES.indexOf(targetItems[0].status) !== -1,
  createReduxAction: (targetItems: FlowOutputStepRunListItemInfo[]) =>
    openCancelBackgroundJobDialogAction({ id: targetItems[0].backgroundJobId } as IBackgroundJobInfo),
};
